"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFinancingProductForProductId = exports.getFinancingCampaignForVehicleId = exports.getResponseCampaignForVehicleId = exports.getSummaryOnePointFive = exports.getDefaultRequestDataForVehicleId = exports.getDefaultDataForVehicleId = exports.getProductParameterForVehicleId = exports.getFormParameterForVehicleId = exports.getCalculateDataForVehicleId = exports.getFinancingStateRaw = void 0;
const getFinancingStateRaw = (state) => state.financing || {};
exports.getFinancingStateRaw = getFinancingStateRaw;
const getCalculateDataForVehicleId = (state, vehicleId) => {
    const rawState = (0, exports.getFinancingStateRaw)(state);
    const vehicleFinanceData = rawState[vehicleId];
    if (vehicleFinanceData && vehicleFinanceData.calculateData) {
        return vehicleFinanceData.calculateData;
    }
    return {};
};
exports.getCalculateDataForVehicleId = getCalculateDataForVehicleId;
const getFormParameterForVehicleId = (state, vehicleId) => {
    const rawState = (0, exports.getFinancingStateRaw)(state);
    const vehicleFinanceData = rawState[vehicleId];
    if (vehicleFinanceData && vehicleFinanceData.formParameter) {
        return vehicleFinanceData.formParameter;
    }
    return {};
};
exports.getFormParameterForVehicleId = getFormParameterForVehicleId;
const getProductParameterForVehicleId = (state, vehicleId) => {
    const rawState = (0, exports.getFinancingStateRaw)(state);
    const vehicleFinanceData = rawState[vehicleId];
    if (vehicleFinanceData && vehicleFinanceData.productParameter) {
        return vehicleFinanceData.productParameter;
    }
    return {};
};
exports.getProductParameterForVehicleId = getProductParameterForVehicleId;
const getDefaultDataForVehicleId = (state, vehicleId) => {
    const rawState = (0, exports.getFinancingStateRaw)(state);
    const vehicleFinancingData = rawState[vehicleId];
    if (vehicleFinancingData && vehicleFinancingData.defaultResponse) {
        return vehicleFinancingData.defaultResponse;
    }
    return {};
};
exports.getDefaultDataForVehicleId = getDefaultDataForVehicleId;
const getDefaultRequestDataForVehicleId = (state, vehicleId) => {
    const rawState = (0, exports.getFinancingStateRaw)(state);
    const vehicleFinancingData = rawState[vehicleId];
    if (vehicleFinancingData && vehicleFinancingData.vehicleData) {
        return vehicleFinancingData.vehicleData;
    }
    return {};
};
exports.getDefaultRequestDataForVehicleId = getDefaultRequestDataForVehicleId;
const getSummaryOnePointFive = (state, vehicleId) => {
    const defaultData = (0, exports.getDefaultDataForVehicleId)(state, vehicleId);
    const { Response = {} } = defaultData;
    const { Result } = Response;
    if (Result) {
        let onePointFive;
        if (Array.isArray(Result)) {
            onePointFive = Result.find((result) => result['@FormatVersion'] === '1.5');
        }
        else {
            onePointFive = Result;
        }
        if (onePointFive && onePointFive.Summaries && onePointFive.Summaries.Summary) {
            return onePointFive.Summaries.Summary;
        }
        return {};
    }
    return {};
};
exports.getSummaryOnePointFive = getSummaryOnePointFive;
const getResponseCampaignForVehicleId = (state, vehicleId) => {
    const defaultData = (0, exports.getDefaultDataForVehicleId)(state, vehicleId);
    const { Response = {} } = defaultData;
    const { Result } = Response;
    if (Result) {
        if (Result.Values && Result.Values.Value) {
            const campaign = Result.Values.Value.filter((value) => value['@ID'] === 'CampaignId');
            return campaign.length && campaign[0]['#text'] ? campaign[0]['#text'] : '';
        }
        return {};
    }
    return {};
};
exports.getResponseCampaignForVehicleId = getResponseCampaignForVehicleId;
const getFinancingCampaignForVehicleId = (state, vehicleId) => {
    const rawState = (0, exports.getFinancingStateRaw)(state);
    const vehicleFinanceData = rawState[vehicleId];
    if (vehicleFinanceData) {
        return vehicleFinanceData.campaign;
    }
    return {};
};
exports.getFinancingCampaignForVehicleId = getFinancingCampaignForVehicleId;
const getFinancingProductForProductId = (state, vehicleId, productId) => {
    const rawState = (0, exports.getFinancingStateRaw)(state);
    const vehicleFinanceData = rawState[vehicleId];
    if (vehicleFinanceData && vehicleFinanceData.products) {
        const { products } = vehicleFinanceData;
        if (Array.isArray(products)) {
            return vehicleFinanceData.products.filter((prod) => prod['@ID'] === productId) || {};
        }
        if (Object.keys(products).length) {
            return products;
        }
        return {};
    }
    return {};
};
exports.getFinancingProductForProductId = getFinancingProductForProductId;
//# sourceMappingURL=financeSelector.js.map